module.exports = __webpack_public_path__ + "static/media/categories.8653948c.svg";